module.exports = "/images/create_app.jpg?c2bd8764fbbdf49a0225c48b0b697f7d";